<template>
  <el-submenu :index="item.path" :popper-append-to-body="false">
    <template slot="title">
      <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
    </template>
    <template v-for="child in item.children">
      <template v-if="!child.hidden">
        <template v-if="hasOneShowingChild(child.children,child) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!child.alwaysShow">
          <menu-item-item :key="child.path" :item="child" :base-path="child.path" :only-one-child="onlyOneChild" />
        </template>
        <template v-else>
          <sub-menu :key="child.path" :item="child" :base-path="child.path" />
        </template>
      </template>
    </template>
  </el-submenu>
</template>
<script>
import path from 'path'
import { isExternal } from '../../../../../src/utils/validate'
import Item from './Item'
import MenuItemItem from './MenuItemItem'
import FixiOSBug from '../../../components/FixiOSBug'

export default {
  name: 'SubMenu',
  components: { Item, MenuItemItem },
  mixins: [FixiOSBug],
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }

  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          this.onlyOneChild = item
          return true
        }
      })
      if (showingChildren.length === 1) {
        return true
      }
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>

